export type HistorySourceKind =
  | "consultation"
  | "vaccine"
  | "exam"
  | "prescription"
  | "term"
  | "grooming"
  | "appointment"
  | "stay";

export type HistorySourceFlags = Record<HistorySourceKind, boolean>;

const ALL_SOURCES_ENABLED: HistorySourceFlags = {
  consultation: true,
  vaccine: true,
  exam: true,
  prescription: true,
  term: true,
  grooming: true,
  appointment: true,
  stay: true,
};

const ALL_SOURCES_DISABLED: HistorySourceFlags = {
  consultation: false,
  vaccine: false,
  exam: false,
  prescription: false,
  term: false,
  grooming: false,
  appointment: false,
  stay: false,
};

type OwnerFilterKind = "all" | Exclude<HistorySourceKind, "appointment">;

export const getEnabledSourcesForOwnerFilter = (typeFilter: OwnerFilterKind): HistorySourceFlags => {
  if (typeFilter === "all") return { ...ALL_SOURCES_ENABLED };
  return { ...ALL_SOURCES_DISABLED, [typeFilter]: true, appointment: false };
};

const PATIENT_SOURCE_KINDS: HistorySourceKind[] = [
  "consultation",
  "vaccine",
  "exam",
  "prescription",
  "term",
  "grooming",
  "appointment",
  "stay",
];

export const getEnabledSourcesForPatientFilters = (selectedFilters: string[]): HistorySourceFlags => {
  const recognized = selectedFilters.filter((filter): filter is HistorySourceKind =>
    (PATIENT_SOURCE_KINDS as string[]).includes(filter),
  );

  if (selectedFilters.length === 0 || selectedFilters.includes("all") || recognized.length === 0) {
    return { ...ALL_SOURCES_ENABLED };
  }

  const flags = { ...ALL_SOURCES_DISABLED };
  recognized.forEach((kind) => {
    flags[kind] = true;
  });
  return flags;
};
